import { z } from 'zod';
import { optionalText, requiredText } from './common';

/** Dados da empresa usados na OS impressa (preparado para logo, dados fiscais e termo de garantia). */
export const companySettingsSchema = z.object({
  name: requiredText(120, 'Nome da empresa'),
  tagline: optionalText(120, 'Subtítulo'),
  legalName: optionalText(160, 'Razão social'),
  document: optionalText(20, 'CNPJ / CPF'),
  stateRegistration: optionalText(30, 'Inscrição estadual'),
  phone: optionalText(30, 'Telefone'),
  email: optionalText(160, 'E-mail'),
  address: optionalText(300, 'Endereço'),
  warrantyTerms: optionalText(5000, 'Termo de garantia'),
  authorizationText: optionalText(1000, 'Texto de autorização'),
  entryText: optionalText(1500, 'Termo de entrada do equipamento'),
  printFooter: optionalText(500, 'Rodapé'),
  emailSubjectTemplate: optionalText(200, 'Assunto do e-mail'),
  emailBodyTemplate: optionalText(5000, 'Mensagem do e-mail'),
});
export type CompanySettingsInput = z.infer<typeof companySettingsSchema>;
